import {SerializedStyles} from '@emotion/react';
import React, {CSSProperties} from 'react';

import {DlMuiChip2ButtonFilled} from './DlMuiChip2ButtonFilled';
import {DlMuiChipButton} from './DlMuiChipButton';
import {DlMuiChipButtonFilled} from './DlMuiChipButtonFilled';
import {DlMuiChipGrayButton} from './DlMuiChipGrayButton';
import {DlMuiChipRedButton} from './DlMuiChipRedButton';
import {DLMuiTextButton} from './DlMuiTextButton';
import {DlMuiTextGrayButton} from './DlMuiTextGrayButton';
import {DlMuiTextWhiteButton} from './DlMuiTextWhiteButton';

export type ButtonType = 'chip' | 'chip-red' | 'chip-gray' | 'chip-filled' | 'chip2-filled' | 'text' | 'text-gray' | 'text-white';
interface OwnProps {
  type: ButtonType;
  title: string;
  tooltip?: string;
  onClick?: (event: any) => void;
  disabled?: boolean;
  disabledTooltip?: string;
  big?: boolean;
  regular?: boolean;
  leftIcon?: JSX.Element;
  style?: CSSProperties;
  css?: SerializedStyles;
}

type Props = OwnProps;

export const DlMuiButton: React.FC<Props> = (props) => {
  const {type, title, big, regular, leftIcon, children: _, ...restProps} = props;

  switch (type) {
    case 'chip':
      return <DlMuiChipButton big={big} title={title} leftIcon={leftIcon} {...restProps} />;
    case 'chip-red':
      return <DlMuiChipRedButton big={big} title={title} leftIcon={leftIcon} {...restProps} />;
    case 'chip-gray':
      return <DlMuiChipGrayButton big={big} title={title} leftIcon={leftIcon} {...restProps} />;
    case 'chip-filled':
      return <DlMuiChipButtonFilled big={big} title={title} leftIcon={leftIcon} {...restProps} />;
    case 'chip2-filled':
      return <DlMuiChip2ButtonFilled big={big} leftIcon={leftIcon} title={title} {...restProps} />;
    case 'text-gray':
      return <DlMuiTextGrayButton title={title} regular={regular} {...restProps} />;
    case 'text-white':
      return <DlMuiTextWhiteButton title={title} regular={regular} {...restProps} />;
    default:
      return <DLMuiTextButton title={title} regular={regular} {...restProps} />;
  }
};

DlMuiButton.displayName = 'DlMuiButton';
